var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.52,
    height: 13.768,
    viewBox: "0 0 15.52 13.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M16.093,4.579a4.882,4.882,0,0,0-6.334-.5,4.867,4.867,0,0,0-6.334,7.358l4.82,4.828a2.158,2.158,0,0,0,3.027,0l4.82-4.828A4.867,4.867,0,0,0,16.093,4.579ZM15,10.37l-4.82,4.82a.59.59,0,0,1-.838,0L4.52,10.346A3.293,3.293,0,0,1,9.177,5.689a.776.776,0,0,0,1.1,0A3.315,3.315,0,0,1,15,10.346Z",
    transform: "translate(-1.988 -3.121)",
    fill: "#8d8d8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.acc6c4d499ae100d60c04e08eaec0b97.svg";
export { ForwardRef as ReactComponent };